import type { RichContent } from 'ricos-schema';

import type { DraftContent } from '../../../../types';
import { fromDraft } from '../fromDraft';

type TestValues = {
  type: string;
  expectedOutput: RichContent;
  input: DraftContent;
};

export const testPlugin = (describeText: string, testValues: TestValues[]) => {
  describe('From draft conversion', () => {
    describe(describeText, () => {
      it.each(testValues)('$type', ({ input, expectedOutput }) => {
        const convertedFromDraft = fromDraft(input);

        expect(convertedFromDraft.nodes).toEqual(expectedOutput.nodes);
        expect(convertedFromDraft.documentStyle).toEqual(expectedOutput.documentStyle);
      });
    });
  });
};
